import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export const DEFAULT_SNACKBAR_OPTIONS_PROVIDER = {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: {
        duration: 2500,
        panelClass: ['bg-gray-800', 'text-gray-100', 'tracking-wide'],
    },
};
